import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { STATUSES } from '../../views/login/Login';
import { BASE_URL } from '../../../config/environmentConfig';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';

export const ApplicationViewHeaderInformation: FC = () => {
  const { merchantState: { applicationViewData }} = useMerchants();

  const getTitle = (): string => {
    switch (applicationViewData?.statusName) {
      case STATUSES.DRAFT:
        return 'Welcome to FlexFactor Portal!';
      case STATUSES.IN_REVIEW:
        return 'Almost done.';
        case STATUSES.SUBMITTED:
        return 'Your Application is being reviewed';
      default:
        return 'Welcome to FlexFactor!';
    }
  };

  const getText = (): string => {
    switch (applicationViewData?.statusName) {
      case STATUSES.DRAFT:
        return 'You are a few steps away from your processing account, please fill in the application below:';
      case STATUSES.IN_REVIEW:
        return 'Please review your info and Merchant Agreement.';
      case STATUSES.SUBMITTED:
        return 'Thank you for submitting your details. We are now processing them and we’ll activate your account in no time.';
      default:
        return 'You are a few steps away from your processing account, please fill in the application below:';
    }
  };

  return(
    <div className="card self-onboarding-header mb-10">
      <div className="card-body">
        <div className="d-flex align-items-start">
          <FontAwesomeIcon
            icon={STATUSES.SUBMITTED ? faCircleCheck : faInfoCircle}
            width={16}
            className="h-20px mt-1 me-5 primary-black"
          />
          <div>
            <div className="fs-5 fw-bolder">{getTitle()}</div>
            <div className="fs-7 mt-3">{getText()}</div>
            {/*{*/}
            {/*  applicationViewData?.statusName === STATUSES.SUBMITTED && (*/}
            {/*    <ButtonComponent*/}
            {/*      additionalClass="btn-sm mt-5 fs-5"*/}
            {/*      buttonType={BUTTON_TYPE.DEFAULT_BLACK}*/}
            {/*    >*/}
            {/*      <a*/}
            {/*        href={BASE_URL.GUIDES_URL}*/}
            {/*        target="_blank"*/}
            {/*        className="fs-6 link-styles text-white"*/}
            {/*        rel="noreferrer"*/}
            {/*      >*/}
            {/*        Read the documentation*/}
            {/*      </a>*/}

            {/*    </ButtonComponent>*/}
            {/*  )*/}
            {/*}*/}
          </div>
        </div>

      </div>
    </div>
  );
};
